import {globals, globalUser} from "../modules/globals.js";
import {
    loadViewCompaniesPage,
    loadViewObjectivesPage,
    loadManagementActivityPage,
    loadFanHistoryPage,
    loadViewCompanyStaffPage,
    loadViewCompanyFacilitiesPage,
    loadViewYearlyRankingsHistoryPage,
    loadViewAnnualTournamentHistoryPage,
    loadViewSpecialSegmentsPage,
    loadViewPowerupsPage,
    loadViewOptionsPage,
    loadViewEventsPage,
    loadViewFeudsPage,
    loadViewStatsPage,
    loadViewTournamentsPage,
    loadViewGimmickMatchesPage, loadViewTitlesPage
} from "./manage-sub-menu.js";
import {loadViewRosterPage, loadViewIndiesPage, loadViewTeamsPage, loadViewManagersPage,
    loadMakeTradeOfferPage, loadViewRankingsPage, loadViewFactionsPage} from "./roster-sub-menu.js";
import {dashboardHandler} from "./dashboard.js";
import {playSoundEffect} from "./sounds.js"
import {loadViewSegmentsPage} from "./custom-segments.js";
import {loadViewBrandsPage} from "./brands.js";
import {messageClickHandler} from "./messages.js";
import {makeGameRequest} from "./ui-helpers.js";
import {playEvent} from "../modules/events.js";
import {showPlayEventData} from "./events.js"
import {loadHomePage} from "./home-page.js";
import {changeCurrentCompany, getUserCompanies} from "../modules/companies.js";
import {getCurrentGame} from "../modules/helpers.js";
import {checkTutorialStepAction} from "./tutorial.js";

$(document).ready(function() {
    // Sub menu button handlers
    const $mainMenuRight = $('#main-menu-right');
    $mainMenuRight.on('click', '#view-companies-menu-button', () => loadViewCompaniesPage());
    $mainMenuRight.on('click', '#view-objectives-menu-button', () => loadViewObjectivesPage());
    $mainMenuRight.on('click', '#view-management-activity-menu-button', () => loadManagementActivityPage());
    $mainMenuRight.on('click', '#view-fan-history-menu-button', () => loadFanHistoryPage());
    $mainMenuRight.on('click', '#view-roster-menu-button', () => loadViewRosterPage());
    $mainMenuRight.on('click', '#view-indies-menu-button', () => loadViewIndiesPage());
    $mainMenuRight.on('click', '#view-teams-menu-button', () => loadViewTeamsPage());
    $mainMenuRight.on('click', '#view-managers-menu-button', () => loadViewManagersPage());
    $mainMenuRight.on('click', '#make-trade-offer-menu-button', () => loadMakeTradeOfferPage());
    $mainMenuRight.on('click', '#view-rankings-menu-button', () => loadViewRankingsPage());
    $mainMenuRight.on('click', '#view-brands-menu-button', () => loadViewBrandsPage());
    $mainMenuRight.on('click', '#view-factions-menu-button', () => loadViewFactionsPage());
    $mainMenuRight.on('click', '#view-company-staff-menu-button', () => loadViewCompanyStaffPage());
    $mainMenuRight.on('click', '#view-company-facilities-menu-button', () => loadViewCompanyFacilitiesPage());
    $mainMenuRight.on('click', '#view-yearly-rankings-history-menu-button', () => loadViewYearlyRankingsHistoryPage());
    $mainMenuRight.on('click', '#view-annual-tournament-history-menu-button', () => loadViewAnnualTournamentHistoryPage());
    $mainMenuRight.on('click', '#view-special-segments-menu-button', () => loadViewSpecialSegmentsPage());
    $mainMenuRight.on('click', '#view-powerups-menu-button', () => loadViewPowerupsPage());
    $mainMenuRight.on('click', '#view-options-menu-button', () => loadViewOptionsPage());
    $mainMenuRight.on('click', '#view-events-menu-button', () => loadViewEventsPage());
    $mainMenuRight.on('click', '#view-feuds-menu-button', () => loadViewFeudsPage());
    $mainMenuRight.on('click', '#view-stats-menu-button', () => loadViewStatsPage());
    $mainMenuRight.on('click', '#view-tournaments-menu-button', () => loadViewTournamentsPage());
    $mainMenuRight.on('click', '#view-gimmick-matches-menu-button', () => loadViewGimmickMatchesPage());
    $mainMenuRight.on('click', '#view-segments-menu-button', () => loadViewSegmentsPage());
    $mainMenuRight.on('click', '#view-titles-menu-button', () => loadViewTitlesPage());
});

function manageHandler() {
    playSoundEffect('success');
    $('.main-menu-container').find('li').removeClass('selected');
    $(this).addClass('selected');

    // Hide event effects
    $('.event-prestige-effects-container').hide();
    $('.event-prestige-effects-more i').addClass('fa-angle-down').removeClass('fa-angle-up');

    let segmentsHtml = '';
    if (globalUser.paid) {
        segmentsHtml = '<li id="view-segments-menu-button">' +
        '<span>Segments</span>' +
        '</li>'
    }
    else {
        segmentsHtml = '<li class="disabled help-text" title="JoW Paid includes Custom Segments.">' +
            '<span>Segments</span>' +
            '</li>'
    }

    let statsHtml;
    if (!globalUser.paid) {
        statsHtml = '<li class="disabled help-text" title="JoW Paid includes Company Stats.">' +
            '<span>Stats</span>' +
            '</li>'
    }
    else {
        statsHtml = '<li id="view-stats-menu-button">' +
            '<span>Stats</span>' +
            '</li>'
    }

    let powerups = 'Artifacts';
    let imgName = 'powerup_1_icon_small.png';
    if (globals.game.story === 'mars') {
        powerups = 'Lab';
        imgName = 'experiment_1_icon_small.png'
    }

    let fanHistoryHtml = '';
    if ((globalUser.paid || globals.currentTutorialStep)) {
        fanHistoryHtml = '<li id="view-fan-history-menu-button">' +
            '<span>Fan History</span>' +
            '</li>'
    }
    else {
        if (!globalUser.paid) {
            fanHistoryHtml = '<li class="disabled help-text" title="JoW Paid includes Fan History.">' +
                '<span>Fan History</span>' +
                '</li>'
        }
    }

    let viewFactionsHtml = '';
    if (globalUser.paid) {
        viewFactionsHtml = '<li id="view-factions-menu-button">' +
            '<span>Factions</span>' +
            '</li>';
    }
    else {
        viewFactionsHtml = '<li class="disabled help-text" title="JoW Paid includes Factions.">' +
            '<span>Factions</span>' +
            '</li>'
    }

    let viewManagersHtml = '';
    if (globalUser.paid) {
        viewManagersHtml = '<li id="view-managers-menu-button">' +
            '<span>Managers</span>' +
            '</li>';
    } else {
        viewManagersHtml = '<li class="disabled help-text" title="JoW Paid includes Managers.">' +
            '<span>Managers</span>' +
            '</li>'
    }

    let viewRankingsHtml = '';
    if (globalUser.paid) {
        viewRankingsHtml = '<li id="view-rankings-menu-button">' +
            '<span>Rankings</span>' +
            '</li>';
    } else {
        viewRankingsHtml = '<li class="disabled help-text" title="JoW Paid includes Roster Rankings.">' +
            '<span>Rankings</span>' +
            '</li>'
    }

    let viewBrands = '';
    if (globalUser.paid) {
        viewBrands = '<li id="view-brands-menu-button">' +
            '<span>Brands</span>' +
            '</li>';
    } else {
        viewBrands = '<li class="disabled help-text" title="JoW Paid includes Brands.">' +
            '<span>Brands</span>' +
            '</li>'
    }

    let viewYearlyHistoryHtml = '';
    let viewAnnualTournamentHistoryHtml = '';
    if (globalUser.paid) {
        viewYearlyHistoryHtml = '<li id="view-yearly-rankings-history-menu-button">' +
            '<span>Top 50</span>' +
            '</li>';
        if (!globals.game.story) {
            viewAnnualTournamentHistoryHtml = '<li id="view-annual-tournament-history-menu-button">' +
                '<span>TGI</span>' +
                '</li>';
        }
    } else {
        viewYearlyHistoryHtml = '<li class="disabled help-text" title="JoW Paid includes Top 50 Rankings.">' +
            '<span>Top 50</span>' +
            '</li>';
    }
    let manageHistoryHtml = '<li id="manage-history" class="button-dropdown">' +
        '<div class="dropdown-toggle">History <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
        '<ul class="dropdown-menu">' +
            viewYearlyHistoryHtml +
            viewAnnualTournamentHistoryHtml +
        '</ul>' +
    '</li>';

    const $mainMenuRight = $("#main-menu-right");
    $mainMenuRight.fadeIn('fast');
    $mainMenuRight.html(
        '<nav class="nav margin-top-20">' +
        '<ul>' +

        '<li id="manage-roster" class="button-dropdown">' +
            '<div class="dropdown-toggle">Roster <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
            '<ul class="dropdown-menu">' +
                '<li id="view-roster-menu-button">' +
                    '<span>View</span>' +
                '</li>' +
                '<li id="view-teams-menu-button">' +
                    '<span>Teams</span>' +
                '</li>' +
                viewFactionsHtml +
                viewManagersHtml +
                '<li id="view-indies-menu-button">' +
                    '<span>Indies</span>' +
                '</li>' +
                '<li id="make-trade-offer-menu-button">' +
                    '<span>Trade</span>' +
                '</li>' +
                viewRankingsHtml +
                viewBrands +
            '</ul>' +
        '</li>' +

        '<li id="manage-company" class="button-dropdown">' +
            '<div class="dropdown-toggle">Company <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
            '<ul class="dropdown-menu">' +
                '<li id="view-events-menu-button">' +
                    '<span>Events</span>' +
                '</li>' +
                '<li id="view-feuds-menu-button">' +
                    '<span>Feuds</span>' +
                '</li>' +
                '<li id="view-titles-menu-button">' +
                    '<span>Titles</span>' +
                '</li>' +
                '<li id="view-gimmick-matches-menu-button">' +
                    '<span>Gimmick Matches</span>' +
                '</li>' +
                segmentsHtml +
                statsHtml +
                '<li id="view-tournaments-menu-button">' +
                    '<span>Tourn.</span>' +
                '</li>' +
            '</ul>' +
        '</li>' +

        '<li id="manage-job" class="button-dropdown">' +
            '<div class="dropdown-toggle">Job <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
            '<ul class="dropdown-menu">' +
                '<li id="view-objectives-menu-button">' +
                    '<span>Goals</span>' +
                '</li>' +
                '<li id="view-management-activity-menu-button">' +
                    '<span>Activity</span>' +
                '</li>' +
                '<li id="view-companies-menu-button">' +
                    '<span>Companies</span>' +
                '</li>' +
                fanHistoryHtml +
            '</ul>' +
        '</li>' +

        '<li id="manage-staff" class="button-dropdown">' +
            '<div class="dropdown-toggle">Staff <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
            '<ul class="dropdown-menu">' +
                '<li id="view-company-staff-menu-button">' +
                    '<span>View</span>' +
                '</li>' +
                '<li id="view-company-facilities-menu-button">' +
                    '<span>Facilities</span>' +
                '</li>' +
            '</ul>' +
        '</li>' +

        manageHistoryHtml +

        '<li id="manage-other" class="button-dropdown">' +
            '<div class="dropdown-toggle">Other <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
            '<ul class="dropdown-menu">' +
                '<li id="view-powerups-menu-button">' +
                    '<span><img alt="Artifact" src="static/www/static/' + imgName + '" class="margin-right-6 top-2px"/>' + powerups + '</span>' +
                '</li>' +
                '<li id="view-special-segments-menu-button">' +
                    '<span><img alt="Special Segment" src="static/www/static/special_segments_icon_small.png" class="margin-right-6 top-2px"/>Special</span>' +
                '</li>' +
            '</ul>' +
        '</li>' +

        '<li id="view-options-menu-button">' +
        'Options' +
        '</li>' +

        '</ul>' +
        '</nav>'
    );

    // Tutorial action check
    checkTutorialStepAction('click_manage_button');
}

function bookHandler() {
    $('.main-menu-container').find('li').removeClass('selected');
    $(this).addClass('selected');

    // Simulator
    let simulator;
    if (!globalUser.paid) {
        simulator = '<li class="disabled help-text" title="JoW Paid includes the Simulator">' +
            '<span>Simulator</span>' +
            '</li>'
    }
    else if (globals.game.controlMultipleCompanies) {
        simulator = '<li class="disabled help-text" title="The Simulator is not available in Local Multiplayer">' +
            '<span>Simulator</span>' +
            '</li>'
    }
    else if (globals.game.story) {
        simulator = '<li class="disabled help-text" title="The Simulator is not available in Stories">' +
            '<span>Simulator</span>' +
            '</li>'
    }
    else {
        simulator = '<li id="simulator-menu-button">' +
            '<span>Simulator</span>' +
            '</li>'
    }

    // Auto booker
    let autoBooker =
            '<li id="auto-book-menu-button" class="button-dropdown">' +
                '<div class="dropdown-toggle">Auto <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
                '<ul class="dropdown-menu">' +
                    '<li id="auto-book-button">' +
                        '<span>Booker</span>' +
                    '</li>' +
                    simulator +
                '</ul>' +
            '</li>';

    // Tournament
    let tournament = '';
    if (!globals.game.weeklyShow) {
        tournament =
            '<li id="add-tournament-menu-button">' +
            'Tournament' +
            '</li>'
    }
    else {
        tournament = '<li class="disabled help-text" title="Tournaments can only be created at Monthly Events">' +
            'Tournament' +
            '</li>'
    }

    // Book segment
    let bookSegment = '';
    if (globals.game.story !== 'mars') {
        bookSegment = '<li id="book-segment-menu-button">' +
        'Segment' +
        '</li>';
    }

    let bookMatch = '<li id="book-singles-menu-button">' +
            'Singles' +
            '</li>' +
            '<li id="book-tag-team-menu-button">' +
            'Tag Team' +
            '</li>';

    $("#main-menu-right").fadeIn('slow', function() {
        $("#main-menu-right").html(
            '<div id="booking-menu">' +
            '<nav class="nav margin-top-20">' +
            '<ul>' +
            bookSegment +
            bookMatch +
            autoBooker +
            tournament +
            '</ul>' +
            '</nav>' +
            '</div>'
        );

        // Reset roster div
        if (globals.game.weeklyShow) {
            // Trigger segment button
            $("#book-segment-menu-button").trigger('click');
        }
        else {
            // Trigger singles match button
            $("#book-singles-menu-button").trigger('click');
        }
    });
}

async function playEventHandler(skipTrainingRosterCallup, skipConfirmStartEvent) {
    if (typeof(skipTrainingRosterCallup) === 'undefined') skipTrainingRosterCallup = globalUser.developerMode;
    if (typeof(skipConfirmStartEvent) === 'undefined') skipConfirmStartEvent = globalUser.developerMode;

    let clickPlayEventTutorialStep = globals.currentTutorialStep && globals.currentTutorialStep['action'] === 'click_play_event';
    if (!skipConfirmStartEvent && !clickPlayEventTutorialStep) {
        notie.confirm({
            text: "Are you sure you want to play the Event?",
            submitText: 'Yes',
            cancelText: 'No',
            submitCallback: async function () {
                await playEventHandler(false, true)
            }
        });
    }
    else {
        await makeGameRequest(playEvent, {skipTrainingRosterCallup}, showPlayEventData, {});
    }
}

async function changeCompanyHandler() {
    $("#main-menu-right").html('');
    $('.main-menu-container').find('li').removeClass('selected');

    if (globals.game.numberOfUserCompanies === 2) {
        await makeGameRequest(changeCurrentCompany, {}, showChangeCurrentCompanyData, {});
    }
    else {
        await makeGameRequest(getUserCompanies, {}, showGetUserCompaniesData, {});
    }
}

function showGetUserCompaniesData({data} = {}) {
    $('.company-selection-companies-container').html('');

    data['companies'].forEach(function (company) {
        let selectedClass = '';
        if (company['name'] === data['currentCompanyName']) {
            selectedClass = ' selected'
        }
        if (company['turnStatus'] === 'ended') {
            selectedClass = ' disabled'
        }
        let playerNameHtml = '';
        if (company['playerName']) {
            playerNameHtml = '<span class="light-grey margin-left-8">{0}</span>'.format(company['playerName']);
        }
        let div =
            '<div class="inner-box-item company-selection-item font-bold' + selectedClass + '" data-uid="' + company['uid'] + '">' +
            company['name'] + playerNameHtml +
            '</div>';
        $('.company-selection-companies-container').append(div);
    })

    $('#company-selection-container').hide().fadeIn('fast');
    $('.company-selection-companies-container').scrollTop(0);
    $('#company-selection-container')[0].scrollIntoView();
}

async function showChangeCurrentCompanyData({data, $el} = {}) {
    if (!data['error']) {
        if ($el) {
            // Select, unselect
            $('.company-selection-item').removeClass('selected');
            $el.addClass('selected');
        }
        await loadHomePage(await getCurrentGame());
    }
    else {
        if (data['error'] === 'company-not-found') {
            notie.alert({type: 3, text: 'That company could not be found. Please try again.'})
        }
        if (data['error'] === 'turn-ended') {
            notie.alert({type: 3, text: data['playerName'] + '\'s turn has ended. Finish your turn to continue.'})
        }
    }
}

function resetMenuButtonClickHandlers(funcToAdd) {
    const $bookMenuButton = $("#book-menu-button");
    const $manage = $("#manage");
    const $playEvent = $("#play-event");
    const $messages = $("#messages");
    const $viewDashboardMenuButton = $("#view-dashboard-menu-button");
    const $changeCompanyButton = $(".change-company-button");

    // Remove click handlers
    $bookMenuButton.off('click');
    $manage.off('click');
    $playEvent.off('click');
    $messages.off('click');
    $viewDashboardMenuButton.off('click');
    $changeCompanyButton.off('click');

    if (funcToAdd) {
        // Add default click handlers
        if (funcToAdd === 'default') {
            $bookMenuButton.on('click', '', bookHandler);
            $manage.on('click', '', manageHandler);
            $playEvent.on('click', '', playEventHandler);
            $messages.on('click', '', messageClickHandler);
            $viewDashboardMenuButton.on('click', '', dashboardHandler);
            $changeCompanyButton.on('click', '', changeCompanyHandler);
        }
        // Add same click handler (disabled etc)
        else {
            $bookMenuButton.on('click', funcToAdd);
            $manage.on('click', funcToAdd);
            $playEvent.on('click', funcToAdd);
            $messages.on('click', funcToAdd);
            $viewDashboardMenuButton.on('click', funcToAdd);
            $changeCompanyButton.on('click', funcToAdd);
        }
    }

    if (funcToAdd === tournamentMenuButtonHandler) {
        $changeCompanyButton.on('click', '', changeCompanyHandler);
    }
}

function disabledMenuButtonHandler() {
    notie.alert({
        type: 4,
        text: "Please finish the current action before proceeding"
    });
}

function tournamentMenuButtonHandler() {
    notie.alert({
        type: 4,
        text: "You cannot perform this action right now"
    });
}

function gameOverMenuButtonHandler() {
    notie.alert({
        type: 4,
        text: "This game is over. You can try again by starting a new game."
    });
}

export {resetMenuButtonClickHandlers, disabledMenuButtonHandler, playEventHandler, tournamentMenuButtonHandler,
    gameOverMenuButtonHandler, manageHandler, showChangeCurrentCompanyData}